import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=77cf35f4&scoped=true"
import script from "./upload.vue?vue&type=script&setup=true&lang=js"
export * from "./upload.vue?vue&type=script&setup=true&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=77cf35f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cf35f4",
  null
  
)

export default component.exports